import React from 'react';
import { ImageGalleryItemWrap, Image } from './ImageGalleryItem.styled';
import GalleryContext from '../GalleryContext';
import { useContext } from 'react';
import { openModal } from 'components/actions';

const ImageGalleryItem = ({ item, id, describe }) => {
  const { dispatch } = useContext(GalleryContext);
  const onOpenModal = e => dispatch(openModal(e.target.id));
  return (
    <ImageGalleryItemWrap>
      <Image id={id} src={item} alt={describe} onClick={onOpenModal} />
    </ImageGalleryItemWrap>
  );
};

export default ImageGalleryItem;
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
//--------------------------------------------------------------------------------
// const ImageGalleryItem = ({ item, id, describe, pictureForModal }) => {
//   return (
//     <ImageGalleryItemWrap>
//       <Image id={id} src={item} alt={describe} onClick={pictureForModal} />
//     </ImageGalleryItemWrap>
//   );
// };
